import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "@/components/ui/toaster"
import LandingPage from '@/pages/LandingPage'
import NotFound from '@/pages/NotFound'
import SentryTest from '@/pages/SentryTest'

const queryClient = new QueryClient()
const ADMIN_URL = import.meta.env.VITE_ADMIN_URL || 'http://localhost:4001'

function AdminRedirect({ path }: { path: string }) {
  useEffect(() => {
    window.location.replace(`${ADMIN_URL}${path}`)
  }, [path])

  return null
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/home" element={<LandingPage />} />
            <Route path="/register" element={<AdminRedirect path="/register" />} />
            <Route path="/login" element={<AdminRedirect path="/login" />} />
            <Route path="/reset-password" element={<AdminRedirect path="/reset-password" />} />
            <Route path="/_sentry-test" element={<SentryTest />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </TooltipProvider>
    </QueryClientProvider>
  )
}

export default App
